import {createAction} from '@reduxjs/toolkit'

import {EntryMethodType, PickUpLocationType} from '@web/core/constants'

/** 수령위치 타입 변경 */
export const setPickUpLocation = createAction<{
    type: Maybe<PickUpLocationType>
    content: string
}>('deliveryInfo/setPickUpLocation')

/** 출입방법 타입 변경 */
export const setEntryMethod = createAction<{
    type: EntryMethodType
    content: string
}>('deliveryInfo/setEntryMethod')

/** 항상 위 수령 위치 및 출입 방법 사용 여부 변경 */
export const setPickUpLocationAlwaysUse = createAction<boolean>('deliveryInfo/setPickUpLocationAlwaysUse')
